export default __webpack_public_path__ + "static/media/element_13.5951a73e.avif";